// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mt-10[data-v-1cc3e7c4]{margin-top:10px}.mt-20[data-v-1cc3e7c4]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
